module.exports = __webpack_public_path__ + "static/media/food-truck-cover.87b607ce.png";